import { useNavigate, useLocation } from 'react-router-dom';
import {normalize} from '../utils/Utilities';

export const useNavigation = () => {
    const navigate = useNavigate();
    const location = useLocation();

    const nonDynamicPath = (path: string) => {
        navigate(path);
    };
    
    const goLanding = () => nonDynamicPath('/')
    const goAbout = () => nonDynamicPath('/about');
    const goProjects = () => nonDynamicPath('/projects');
    const goStories = () => nonDynamicPath('/stories');
    const goBlogStories = (title: string) => {
        navigate(`/blog/${normalize(title)}`);
    };

    const goWorkProjects = (title: string) => {
        navigate(`/work/${normalize(title)}`);

    }

    return {
        goLanding,
        goAbout,
        goProjects,
        goWorkProjects,
        goStories,
        goBlogStories,
        location,
    };
};